<template>
  <div id="addReportTaskContainer">
      <form id="reportTaskForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.taskName')}}:</div>
                <input name="taskName" v-model="monitorTask.taskName" 
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox" style="display: none">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.product')}}:</div>
                <input name="product" v-model="monitorTask.product"  readonly="readonly"
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.record.diskSpaceThreshold')}}:</div>
              <input name="spaceThreshold" :placeholder="$t('Monitor.record.diskSpaceThreshold')" v-model="monitorThresholdPo.spaceThreshold" 
                     class="e-input e-input-group" maxlength="20" />
              <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.record.cpuThreshold')}}:</div>
                <input name="cpuThreshold" v-model="monitorThresholdPo.cpuThreshold" 
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.record.memoryThreshold')}}:</div>
                <input name="memoryThreshold" v-model="monitorThresholdPo.memoryThreshold"
                    class="e-input e-input-group" maxlength="20" />
                <div class="error"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.sampleStart')}}:</div>
                <ejs-datepicker :format="dateFormat" v-model="monitorTask.sampleStart" ref="startTime" name="sampleStart" readonly="readonly"
                    class="e-input" :allowEdit="false" @keydown.native="stopEvent" :locale="locale"></ejs-datepicker>
            </div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
                <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Monitor.task.sampleEnd')}}:</div>
                <ejs-datepicker :format="dateFormat" v-model="monitorTask.sampleEnd" ref="endTime" name="sampleEnd" readonly="readonly"
                    class="e-input" :allowEdit="false" @keydown.native="stopEvent" :locale="locale"></ejs-datepicker>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
    import { CheckBoxSelection } from '@syncfusion/ej2-vue-dropdowns';
    import { FormValidator } from "@syncfusion/ej2-vue-inputs";
    import mixin from '../../../mixin/mixin';

    export default {
        name: 'AddReportTask',
        mixins: [mixin],
        displayFlag : 'none',
        props: {
            baseType: Number,
        },
        components: {
        },
        data() {
            return {
                formValidator: '',
                dateFormat: "yyyy-MM-dd HH:mm:ss",
                locale: localStorage.getItem('locale'),
                currentDay: new Date(),
                monitorTask: {
                    taskId:'',
                    taskName: '',
                    product: '',
                    sampleStart: '',
                    sampleEnd: '',
                },
                monitorThresholdPo: {
                    cpuThreshold: '',
                    memoryThreshold: '',
                    spaceThreshold: '',
                },
                productList: [],
                fieldsFormat: {
                    text: "text",
                    value: "value"
                },
                formatList: [
                    { text: "csv", value: "csv" },
                    { text: "excel", value: "excel" },
                ],
                 validateOptions: {
                    customPlacement: function(inputElement, errorElement) {
                      console.log("******validateOptions-inputElement:", inputElement)
                      console.log("******validateOptions-errorElement:", errorElement)

                        inputElement = inputElement.closest('.form-group').querySelector('.error');
                        inputElement.parentElement.appendChild(errorElement);
                    },
                    rules: {
                        'taskName': {
                            required: [true, `${this.$t('Monitor.placeholder.taskName')}`],
                        },
                        // 'product': {
                        //     required: [true, `${this.$t('Monitor.placeholder.product')}`],
                        // },
                        'cpuThreshold': {
                            number: [true, this.$t('MCS.insertNum')],
                        },
                        'spaceThreshold': {
                            number: [true, this.$t('MCS.insertNum')],
                        },
                        'memoryThreshold': {
                            number: [true, this.$t('MCS.insertNum')],
                        },
                        'sampleStart': {
                            required: [true, `${this.$t('Monitor.placeholder.sampleStart')}`],
                        },
                        'sampleEnd': {
                            required: [true, `${this.$t('Monitor.placeholder.sampleEnd')}`],
                        },
                    }
                }
                
            }
        },
        methods: {
            init(editId){
              this.monitorTask.taskId = editId
                const baseUrl = '/lte/ems/sys/monitor/task/queryId';
                const params = { params: {
                    id: editId
                } };
                const That = this;
                this.axios.get(baseUrl, params).then(response => {
                    const result = response.data;
                    var monitorTask = result.monitorTask;
                    this.monitorTask.taskName = monitorTask.taskName;
                    this.monitorTask.product = monitorTask.product;
                    if(monitorTask.sampleStart != null && monitorTask.sampleStart != ''){
                        this.monitorTask.sampleStart = new Date(monitorTask.sampleStart).Format("yyyy-MM-dd HH:mm:ss");
                    }
                    if(monitorTask.sampleEnd != null && monitorTask.sampleEnd != ''){
                        this.monitorTask.sampleEnd = new Date(monitorTask.sampleEnd).Format("yyyy-MM-dd HH:mm:ss");
                    }
                    var monitorThresholdPo = result.monitorThresholdPo;
                    this.monitorThresholdPo.cpuThreshold = monitorThresholdPo.cpuThreshold;
                    this.monitorThresholdPo.memoryThreshold = monitorThresholdPo.memoryThreshold;
                    this.monitorThresholdPo.spaceThreshold = monitorThresholdPo.spaceThreshold;
                });
                this.formValidator = new FormValidator('#reportTaskForm', this.validateOptions);
            },
            getMonitorTask() {
                return {
                    monitorTask: {
                        id:this.monitorTask.taskId,
                        taskName: this.monitorTask.taskName,
                        product: this.monitorTask.product,
                        sampleStart: (new Date(this.monitorTask.sampleStart)).getTime(),
                        sampleEnd: (new Date(this.monitorTask.sampleEnd)).getTime(),
                    },
                    monitorThresholdPo: {
                      cpuThreshold: this.monitorThresholdPo.cpuThreshold,
                      memoryThreshold: this.monitorThresholdPo.memoryThreshold,
                      spaceThreshold: this.monitorThresholdPo.spaceThreshold,
                    },
                 }
            },
            validation() {
              let status = this.formValidator.validate();
              return status;
            },
            stopEvent(event) {
                if (event.keyCode == 13) {
                    event.cancelBubble = true;
                    event.returnValue = false;
                    return false;
                }
            }
        }
    };
</script>
